export const apiUrl =
  process.env.API_URL || "https://apptrackerbackend.herokuapp.com";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
